<template>
	<div class="header-card">
		<div class="header-card-tabs">
			<div class="header-card-tabs-title" :class="tabTitleClass">{{ tabTitle }}</div>
			<div
				v-for="(item, index) in tabs"
				:key="index"
				class="header-card-tabs-item"
				:class="{
					active: value === item.value
				}"
				@click="handleClickTab(item)"
			>
				<template v-if="!hasTabSlot">{{ item.label }}{{ item.count !== undefined ? `(${item.count})` : "" }}</template>
				<slot v-else name="tab-item" :tab="item"></slot>
			</div>
		</div>

		<div class="header-card-line"></div>

		<xbd-filter
			:value="filterData"
			:filter-list="filterList"
			v-bind="filterConfig"
			@input="handleInput"
			@handleSearch="handleSearch"
			@handleMore="handleMore"
		/>
	</div>
</template>

<script>
/**
 * 头部筛选组件（单个tab筛选）
 * @param {String} tabTitle - tab标题
 * @param {Array} tabs - tab列表
 * @param {Array} filterList - 筛选项列表
 * @param {Object} filterData - 筛选数据
 * @param {String|Number} value - 当前选中tab的值
 * @param {Boolean} changeClear - 是否切换tab时清空搜索条件，默认false
 * @param {Object} filterConfig - 筛选配置
 * @param {String} tabTitleClass - 自定义tab标题class
 *
 * @event handleSearch - 点击搜索按钮
 * @event tabClick - 点击tab
 * @event handleMore - 点击更多
 *
 * @slot tab-item - tab自定义内容
 */

import XbdFilter from "@/components/XbdFilter";

export default {
	name: "HeadFilter",
	components: {
		XbdFilter
	},
	props: {
		tabTitle: {
			type: String,
			default: ""
		},
		tabs: {
			type: Array,
			default: () => [],
			required: true
		},
		filterList: {
			type: Array,
			default: () => [],
			required: true
		},
		filterData: {
			type: Object,
			default: () => ({})
		},
		value: {
			type: [String, Number],
			default: ""
		},
		/**
		 * 是否切换tab时清空搜索条件，默认false
		 * @type {Boolean}
		 */
		changeClear: {
			type: Boolean,
			default: false
		},
		filterConfig: {
			type: Object,
			default: () => ({})
		},
		tabTitleClass: {
			type: String,
			default: ""
		}
	},
	methods: {
		handleSearch() {
			this.$emit("search", this.filterData);
		},
		handleClickTab(tab) {
			if (this.changeClear) {
				this.$emit("update:filterData", {});
			}

			this.$emit("input", tab.value);
			this.$emit("tabClick", tab.value, tab);
			this.handleSearch();
		},
		handleMore(value) {
			this.$emit("handle-more", value);
		},
		handleInput(value) {
			this.$emit("update:filterData", value);
		}
	},
	computed: {
		hasTabSlot() {
			return Boolean(this.$slots["tab-item"]) || Boolean(this.$scopedSlots["tab-item"]);
		}
	}
};
</script>

<style scoped lang="scss">
.header-card {
	border-radius: 4px;
	box-sizing: border-box;
	width: 100%;
	background: #fff;
	padding: 16px;

	&-tabs {
		display: flex;
		flex-direction: row;
		flex-wrap: wrap;
		color: #999999;
		align-items: center;
		justify-content: flex-start;
		margin-bottom: 8px;
		box-sizing: border-box;

		&-title {
			font-size: 14px;
			margin-right: 16px;
			margin-bottom: 8px;
			color: #3c424d;
			line-height: 22px;
		}

		&-item {
			display: flex;
			align-items: center;
			color: #74798a;
			line-height: 22px;
			margin-right: 16px;
			padding: 3px 8px;
			margin-bottom: 8px;
			cursor: pointer;

			&.active {
				border-radius: 2px;
				background: #f2f3f5;
				color: #095ce6;
			}
		}
	}

	&-line {
		height: 1px;
		width: 100%;
		background: #e7e8eb;
		margin-bottom: 16px;
	}
}
</style>
